/* eslint-disable */

!((document, Drupal, $, once) => {
  Drupal.behaviors.paleoIsotopeProgram = {

    attach: function (context, settings) {
      var localSettings = settings.paleoIsotopeProgram;

      $(once('paragraphProgram', '.paragraph-program')).each(function () {
        var $paragraph = $(this);
        var $programContainer = $('.paragraph-program-artists', this);
        var isActive = false;

        $('.js-view-switcher', this).on('click', function() {
          $('.paragraph-program-wrapper').trigger('switchView', $paragraph);
        });

        $programContainer.data('uniqueId', paleo.getUid());
        $programContainer.data('uniqueSelector', '.paragraph-program-artists-uid-' + $programContainer.data('uniqueId'));

        $programContainer.addClass('paragraph-program-artists-uid-' + $programContainer.data('uniqueId'));

        // Generate custom css file on the top of the document to handle every program's filter styles
        var programElement = document.createElement('style');
        document.head.appendChild(programElement);
        $programContainer.data('styleSheet', programElement.sheet);


        $(window).bind('resize', function () {
          if (paleo.mixin.isTabletPortrait()) {
            if (!isActive) {
              enableIsotope($programContainer);
              filterContent($programContainer, localSettings);
              isActive = true;
            }
          } else {
            if (isActive) {
              disableIsotope($programContainer);
              filterContent($programContainer, localSettings);
              isActive = false;
            }
          }
        });

        $('.paragraph-program-reset-filters-button', this).click(function () {
          var date = paleo.getQueryParameter('date');
          paleo.setQueryParametersAndPush({'date': date});
        });

        filterContent($programContainer, localSettings);

        if (paleo.mixin.isTabletPortrait()) {
          enableIsotope($programContainer);
          isActive = true;
        }

        window.addEventListener('popstate', function (e) {
          filterContent($programContainer, localSettings, isActive);
        });

        $(this).bind('enableView', function () {
          filterContent($programContainer, localSettings, isActive);
        });
      });
    }
  }

  /**
   * Filter content based on header array. Use isotope when it's initialized. Use custom generated CSS to handle
   * mobile and event display.
   * @param $element
   * @param settings
   * @param isActive
   */
  function filterContent($element, settings, isActive) {
    var parameters = paleo.getQueryParameters();

    var style = $element.data('styleSheet');
    var uniqueSelector = $element.data('uniqueSelector');

    var selectors = [];

    //clear file rules
    for (var i = 0; i < style.cssRules.length; i++) {
      style.deleteRule(0);
    }

    //remove eventual 'program-filter-date-all' class of the program container
    $element.removeClass('program-filter-date-all');


    if (!('date' in parameters)) {
      // to avoid having to get "start date" and "end date" to check if the current date is in the current festival, simply
      // check if the current date is represented with the class filter-date-[current date]. /!\ Doesn't work if the program
      // is empty for the current day, but seems to be the easiest solution.
      var now = paleo.getDate().format('YYYY-MM-DD');

      if ($element.find('.filter-date-' + now).length) {
        parameters['date'] = now;
      }
    }

    if ('date' in parameters) {
      if (parameters['date'] != 'all') {
        var date = parameters['date'];
        selectors.push('.filter-date-' + date);
        style.insertRule('.node.node-event-stripe:not(.node-event-stripe-day-' + date + ') { ' +
          'display: none;' +
          '}',
          0
        );
      } else {
        $element.addClass('program-filter-date-all');
      }
    } else {
      $element.addClass('program-filter-date-all');
    }

    if ('stage' in parameters && parameters['stage'] != 'all') {
      selectors.push('.filter-stage-' + parameters['stage']);
    }

    if ('style' in parameters && parameters['style'] != 'all') {
      selectors.push('.filter-style-' + parameters['style']);
    }

    if ('artist' in parameters && parameters['artist'] != 'all') {
      selectors.push('.filter-artist-' + parameters['artist']);
    }

    if (isActive) {
      // Allow the isotope filtering to work with the quicklinks. Don't need to re-enable after ordering.
      disableIsotope($element);
    }

    orderQuickLinks($element, selectors.join(''), settings);

    if (paleo.mixin.isTabletPortrait()) {
      var selectorsStr = selectors.join('');
      $element.isotope({
        'filter': selectorsStr + (selectorsStr ? ', .node-quicklink-program' : ''),
        transitionDuration: 0
      });
    } else {
      var fullSelectors = selectors.map(function (element) {
        return uniqueSelector + ' .node:not(' + element + ').node:not(.node-quicklink-program)';
      });
      if (fullSelectors.length > 0) {
        style.insertRule(fullSelectors.join(', ') + '{' +
          'visibility: hidden;' +
          'opacity: 0;' +
          'height: 0;' +
          'transform: scale(0);' +
          'padding: 0;' +
          '}', 0);
      }
    }

    if (selectors.length > 0 && $element.find(selectors.join('')).length == 0) {
      $('.paragraph-program-no-artists').show();
    } else {
      $('.paragraph-program-no-artists').hide();
    }
  }

  function orderQuickLinks(programContainer, selectors, settings) {

    var quicklinks = $('.program-quicklinks .node-quicklink-program');
    if (!quicklinks.length) {
      return;
    }

    programContainer.find('.node-quicklink-program').remove();

    // If one or more filters are applied, don't show any quick link
    if (selectors.length) {
      return;
    }

    var displayedArtists = selectors
      ? programContainer.find(selectors)
      : programContainer.find('.node-artist-description-program');
    if (!displayedArtists.length) {
      return;
    }

    var offset = Number(settings.quicklinkOffset);
    var quicklinksArray = quicklinks.toArray();
    var posFromOffset = 0;
    var noQuicklink = 0;

    var quicklinksStep = Math.ceil((displayedArtists.length - offset) / quicklinks.length);
    if (quicklinksStep === 0) {
      quicklinksStep = 1;
    } else if (quicklinksStep > 29) {
      quicklinksStep = 29;
    }

    displayedArtists.each((i, artist) => {
      if (i >= offset - 1) {
        if ((posFromOffset % quicklinksStep) === 0
          && (noQuicklink < quicklinksArray.length || quicklinksStep === 29)) {
          quicklink = $(quicklinksArray[noQuicklink % quicklinksArray.length]).clone();
          $(quicklink).insertBefore($(artist));
          noQuicklink++;
        }
        posFromOffset++;
      }
    });

    // complete missing quicklinks
    if (noQuicklink < quicklinksArray.length) {
      for (var j = noQuicklink; j < quicklinksArray.length; j++) {
        quicklink = $(quicklinksArray[j]).clone();
        programContainer.append(quicklink);
      }
    }
  }

  function enableIsotope($element) {
    $element.isotope({
      itemSelector: '.node',
      percentPosition: true
    });
  }

  function disableIsotope(element) {
    $(element).isotope('destroy');
  }

  // eslint-disable-next-line no-undef
})(document, Drupal, jQuery, once);
